import { Button, Col, Form, message, Row, Tooltip } from 'antd';
import { Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { ImageUpload } from '../form/image-upload';
import { Colors } from '../../constant/color';
import styled from 'styled-components';
import { GeneralState } from '../../store/reducer/general';
import useSWR from 'swr';
import { GeneralApi, ValuationApi } from '../../apis';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import {
  NumberInput,
  RadioGroupInput,
  TextAreaInput,
} from '../form/fields/number-input';
import { formatter, isUrl, parser, scrollAndSubmit } from '../../utils';

const formSchema = Yup.object().shape({
  engineTransmissionCondition: Yup.string().required('Заавал оруулах'),
  warningLightCondition: Yup.string().required('Заавал оруулах'),
  windowCondition: Yup.string().required('Заавал оруулах'),
  lightCondition: Yup.string().required('Заавал оруулах'),
  scratchNote: Yup.string().required('Заавал оруулах'),
  accidentNote: Yup.string().required('Заавал оруулах'),
  saloonCondition: Yup.string().required('Заавал оруулах'),
  odo: Yup.number().required('Заавал оруулах'),
  odoImageId: Yup.string().required('Заавал оруулах'),
  hoodNote: Yup.string().required('Заавал оруулах'),
  hoodImageId: Yup.string().required('Заавал оруулах'),
  frontImageId: Yup.string().required('Заавал оруулах'),
  backImageId: Yup.string().required('Заавал оруулах'),
  rightImageId: Yup.string().required('Заавал оруулах'),
  leftImageId: Yup.string().required('Заавал оруулах'),
  saloonImageId: Yup.string().required('Заавал оруулах'),
});

export interface AdditionalFormDataType {
  engineTransmissionCondition?: string;
  warningLightCondition?: string;
  windowCondition?: string;
  lightCondition?: string;
  scratchNote?: string;
  accidentNote?: string;
  saloonCondition?: string;
  saloonImageId?: string;
  odo?: number;
  odoImageId?: string;
  hoodNote?: string;
  hoodImageId?: string;
  frontImageId?: string;
  backImageId?: string;
  rightImageId?: string;
  leftImageId?: string;
}


type Props = {
  action: {
    loading: boolean;
    payload: any;
    found?: 'ADDITIONAL_DATA' | 'IS_ADDITIONAL_DATA' | boolean;
  };
  payload?: any;
};

const AdditionalForm = ({ action, payload }: Props) => {
  const { data: general } = useSWR<GeneralState>('/api/init', async () => await GeneralApi.init());

  const navigate = useNavigate();

  const initialValues: AdditionalFormDataType = {
    engineTransmissionCondition: undefined,
    warningLightCondition: undefined,
    windowCondition: undefined,
    lightCondition: undefined,
    scratchNote: undefined,
    accidentNote: undefined,
    saloonCondition: undefined,
    saloonImageId: undefined,
    odo: undefined,
    odoImageId: undefined,
    hoodNote: undefined,
    hoodImageId: undefined,
    frontImageId: undefined,
    backImageId: undefined,
    rightImageId: undefined,
    leftImageId: undefined,
    ...(payload
      ? {
          engineTransmissionCondition: payload?.engineTransmissionCondition,
          warningLightCondition: payload?.warningLightCondition,
          windowCondition: payload?.windowCondition,
          lightCondition: payload?.lightCondition,
          scratchNote: payload?.scratchNote,
          accidentNote: payload?.accidentNote,
          hoodNote: payload?.hoodNote,
          saloonCondition: payload?.saloonCondition,
          saloonImageId: payload?.saloonImage?.url,
          hoodImageId: payload?.hoodImage?.url,
          odoImageId: payload?.odoImage?.url,
          frontImageId: payload?.frontImage?.url,
          backImageId: payload?.backImage?.url,
          rightImageId: payload?.rightImage?.url,
          leftImageId: payload?.leftImage?.url,
          odo: payload?.odo,
        }
      : {}),
  };

  const [messageApi] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const successMessage = () => {
    messageApi.open({
      type: 'success',
      content: 'Амжилттай үнэлгээчнээр үнэлүүлэгдлээ.',
    });
  };

  const errorMessage = () => {
    messageApi.open({
      type: 'error',
      content: 'Алдаа гарлаа',
    });
  };

  const onSubmit = async (values: AdditionalFormDataType) => {
    console.log('values :', values);

    if (!values) return;

    const _values = {
      ...values,
      backImageId: isUrl(values.backImageId!) ? payload?.backImageId : values.backImageId,
      frontImageId: isUrl(values.frontImageId!) ? payload?.frontImageId : values.frontImageId,
      hoodImageId: isUrl(values.hoodImageId!) ? payload?.hoodImageId : values.hoodImageId,
      leftImageId: isUrl(values.leftImageId!) ? payload?.leftImageId : values.leftImageId,
      odoImageId: isUrl(values.odoImageId!) ? payload?.odoImageId : values.odoImageId,
      rightImageId: isUrl(values.rightImageId!) ? payload?.rightImageId : values.rightImageId,
      saloonImageId: isUrl(values.saloonImageId!) ? payload?.saloonImageId : values.saloonImageId,
    };

    setLoading(true);
    try {
      await ValuationApi.send({ id: action?.payload?.id, values: _values });
      navigate(NavigationRoutes.Valuation_ListScreen);
      successMessage();
      setLoading(false);
    } catch (error) {
      console.error('error :', error);
      setLoading(false);
      errorMessage();
    }
  };

  if (!general) {
    return null;
  }

  return (
    <Container className="flex flex-col">
      {/* <label className="text-black text-[18px] font-medium mt-[-40px]">Нэмэлт мэдээлэл</label> */}
      {/* <div className="h-[36px]" /> */}
      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue, handleSubmit, errors, touched }) => {
          console.log('OoDoO, ', values?.odo);

          return (
            <Form layout="vertical" onFinish={handleSubmit}>
              <Row gutter={24}>
                <Col span={12} id="engineTransmissionCondition">
                  <Form.Item
                    label="Мотор, хропны ерөнхий чанар, байдал*"
                    name="engineTransmissionCondition"
                    validateStatus={
                      errors.engineTransmissionCondition && touched.engineTransmissionCondition
                        ? 'error'
                        : ''
                    }
                    help={
                      errors.engineTransmissionCondition && touched.engineTransmissionCondition
                        ? errors.engineTransmissionCondition
                        : ''
                    }
                  >
                    <RadioGroupInput
                      name="engineTransmissionCondition"
                      options={general?.engineTransmissionConditions || []}
                    />
                    {/* <AntRadio.Group
                      name="engineTransmissionCondition"
                      onChange={(e) => console.log('engineTransmissionCondition', e.target.value)}
                    >
                      {(general?.engineTransmissionConditions || []).map((item) => (
                        <AntRadio
                          key={item.code}
                          value={item.code}
                          name={'engineTransmissionCondition'}
                        >
                          {item.name}
                        </AntRadio>
                      ))}
                    </AntRadio.Group> */}
                  </Form.Item>
                </Col>

                <Col span={12} id="warningLightCondition">
                  <Form.Item
                    name="warningLightCondition"
                    label="Хянах самбарын гэрэл ассан эсэх"
                    className="warningLightCondition"
                    validateStatus={
                      errors.warningLightCondition && touched.warningLightCondition ? 'error' : ''
                    }
                    help={
                      errors.warningLightCondition && touched.warningLightCondition
                        ? errors.warningLightCondition
                        : ''
                    }
                  >
                    {/* all Checkbox.Group RadioGroup replace */}

                    <RadioGroupInput
                      name="warningLightCondition"
                      options={general?.warningLightConditions || []}
                    />
                    {/* <Group name="warningLightCondition">
                      {(general?.warningLightConditions || []).map((item) => (
                        <Radio key={item.code} value={item.code} name="warningLightCondition">
                          {item.name}
                        </Radio>
                      ))}
                    </Group> */}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12} id="windowCondition">
                  <Form.Item
                    label="Шил бүрэн, бүтэн эсэхийг шалгах"
                    name="windowCondition"
                    validateStatus={
                      errors.windowCondition && touched.windowCondition ? 'error' : ''
                    }
                    help={
                      errors.windowCondition && touched.windowCondition
                        ? errors.windowCondition
                        : ''
                    }
                  >
                    <RadioGroupInput
                      name="windowCondition"
                      options={general?.windowConditions || []}
                    />
                    {/* <Group name="windowCondition">
                      {(general?.windowConditions || []).map((item) => (
                        <Radio name="windowCondition" key={item.code} value={item.code}>
                          {item.name}
                        </Radio>
                      ))}
                    </Group> */}
                  </Form.Item>
                </Col>

                <Col span={12} id="lightCondition">
                  <Form.Item
                    label="Гэрэл, дохио бүрэн бүтэн эсэхийг шалгах"
                    name="lightCondition"
                    validateStatus={errors.lightCondition && touched.lightCondition ? 'error' : ''}
                    help={
                      errors.lightCondition && touched.lightCondition ? errors.lightCondition : ''
                    }
                  >
                    <RadioGroupInput
                      name="lightCondition"
                      options={general?.lightConditions || []}
                    />

                    {/* <Group name="lightCondition">
                      {(general?.lightConditions || []).map((item) => (
                        <Radio name="lightCondition" key={item.code} value={item.code}>
                          {item.name}
                        </Radio>
                      ))}
                    </Group> */}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12} id="scratchNote">
                  <Form.Item
                    label="Онцгойлох зураас, сэв, хонхойлтыг тэмдэглэх"
                    name="scratchNote"
                    validateStatus={errors.scratchNote && touched.scratchNote ? 'error' : ''}
                    help={errors.scratchNote && touched.scratchNote ? errors.scratchNote : ''}
                  >
                    <TextAreaInput
                      name="scratchNote"
                      className="pl-[10px]"
                      placeholder="Нэмэлт тайлбар бичих"
                      style={{ height: '123px' }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} id="accidentNote">
                  <Form.Item
                    label="Осолд орж байсан шинж тэмдэг байгаа эсэхийг сайтар ажиглах*"
                    name="accidentNote"
                    validateStatus={errors.accidentNote && touched.accidentNote ? 'error' : ''}
                    help={errors.accidentNote && touched.accidentNote ? errors.accidentNote : ''}
                  >
                    <TextAreaInput
                      name="accidentNote"
                      className="pl-[10px]"
                      placeholder="Нэмэлт тайлбар бичих"
                      style={{ height: '123px' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12} id="saloonCondition">
                  <Form.Item
                    label="Салоны бохирдол, эвдрэл гэмтэл байгаа эсэхийг шалгах*"
                    name="saloonCondition"
                    validateStatus={
                      errors.saloonCondition && touched.saloonCondition ? 'error' : ''
                    }
                    help={
                      errors.saloonCondition && touched.saloonCondition
                        ? errors.saloonCondition
                        : ''
                    }
                  >
                    <RadioGroupInput
                      name="saloonCondition"
                      options={general?.saloonConditions || []}
                    />

                    {/* <Group name="saloonCondition">
                      {(general?.saloonConditions || []).map((item) => (
                        <Radio name="saloonCondition" key={item.code} value={item.code}>
                          {item.name}
                        </Radio>
                      ))}
                    </Group> */}
                  </Form.Item>
                </Col>

                <Col span={12} id="odo">
                  <Form.Item
                    label="Явсан км"
                    name="odo"
                    validateStatus={errors.odo && touched.odo ? 'error' : ''}
                    help={errors.odo && touched.odo ? errors.odo : ''}
                  >
                    <NumberInput
                      name="odo"
                      size="large"
                      placeholder="Явсан км"
                      style={{ width: '100%' }}
                      suffix={<Tooltip title="Extra information">КМ</Tooltip>}
                      formatter={formatter as any}
                      parser={parser}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12} id="saloonImageId">
                  <Form.Item
                    label="Салоны зураг"
                    validateStatus={errors.saloonImageId && touched.saloonImageId ? 'error' : ''}
                    help={errors.saloonImageId && touched.saloonImageId ? errors.saloonImageId : ''}
                  >
                    <ImageUpload
                      value={values.saloonImageId}
                      validateStatus={errors.saloonImageId && touched.saloonImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('saloonImageId', e)}
                      uploadOnRemove={() => setFieldValue('saloonImageId', undefined)}
                    />
                    {/* <ImageUpload
                      uploadOnChange={(e) => setFieldValue('odoImageId', e)}
                      uploadOnRemove={() => setFieldValue('odoImageId', undefined)}
                    /> */}
                  </Form.Item>
                </Col>

                <Col span={12} id="odoImageId">
                  <Form.Item
                    label="Явсан км зураг"
                    validateStatus={errors.odoImageId && touched.odoImageId ? 'error' : ''}
                    help={errors.odoImageId && touched.odoImageId ? errors.odoImageId : ''}
                  >
                    <ImageUpload
                      value={values.odoImageId}
                      validateStatus={errors.odoImageId && touched.odoImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('odoImageId', e)}
                      uploadOnRemove={() => setFieldValue('odoImageId', undefined)}
                    />
                    {/* <ImageUpload
                      uploadOnChange={(e) => setFieldValue('hoodImageId', e)}
                      uploadOnRemove={() => setFieldValue('hoodImageId', undefined)}
                    /> */}
                  </Form.Item>
                </Col>
              </Row>

              <Col className="w-full" style={{ width: '100%' }}>
                <Row className="w-full" style={{ width: '100%' }}>
                 Моторын зураг + тайлбар (Тос гоожсон / хөлөрсөн / осолд орсон эсэх)
                </Row>
                <Row className="w-full" style={{ width: '100%' }} id="hoodNote">
                  <Form.Item
                    label=""
                    name="hoodNote"
                    style={{ width: '100%' }}
                    validateStatus={errors.hoodNote && touched.hoodNote ? 'error' : ''}
                    help={errors.hoodNote && touched.hoodNote ? errors.hoodNote : ''}
                  >
                    <TextAreaInput
                      name="hoodNote"
                      style={{ height: '123px', width: '100%' }}
                      placeholder="Нэмэлт тайлбар бичих"
                    />
                  </Form.Item>
                  {/*  */}
                </Row>
              </Col>
              <div className="h-[25px]" />
              <Col id="hoodImageId">
                <Form.Item
                  label="Моторын зураг"
                  validateStatus={errors.hoodImageId && touched.hoodImageId ? 'error' : ''}
                  help={errors.hoodImageId && touched.hoodImageId ? errors.hoodImageId : ''}
                >
                  <ImageUpload
                    value={values.hoodImageId}
                    validateStatus={errors.hoodImageId && touched.hoodImageId ? 'error' : ''}
                    uploadOnChange={(e) => setFieldValue('hoodImageId', e)}
                    uploadOnRemove={() => setFieldValue('hoodImageId', undefined)}
                  />
                </Form.Item>
              </Col>

              <div className="h-[25px]" />

              <Row gutter={24}>
                <Col span={12} id="frontImageId">
                  <Form.Item
                    label="Урд тал"
                    validateStatus={errors.frontImageId && touched.frontImageId ? 'error' : ''}
                    help={errors.frontImageId && touched.frontImageId ? errors.frontImageId : ''}
                  >
                    <ImageUpload
                      value={values.frontImageId}
                      validateStatus={errors.frontImageId && touched.frontImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('frontImageId', e)}
                      uploadOnRemove={() => setFieldValue('frontImageId', undefined)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} id="backImageId">
                  <Form.Item
                    label="Ар тал"
                    validateStatus={errors.backImageId && touched.backImageId ? 'error' : ''}
                    help={errors.backImageId && touched.backImageId ? errors.backImageId : ''}
                  >
                    <ImageUpload
                      value={values.backImageId}
                      validateStatus={errors.backImageId && touched.backImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('backImageId', e)}
                      uploadOnRemove={() => setFieldValue('backImageId', undefined)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12} id="leftImageId">
                  <Form.Item
                    label="Зүүн тал"
                    validateStatus={errors.leftImageId && touched.leftImageId ? 'error' : ''}
                    help={errors.leftImageId && touched.leftImageId ? errors.leftImageId : ''}
                  >
                    <ImageUpload
                      value={values.leftImageId}
                      validateStatus={errors.leftImageId && touched.leftImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('leftImageId', e)}
                      uploadOnRemove={() => setFieldValue('leftImageId', undefined)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} id="rightImageId">
                  <Form.Item
                    label="Баруун тал"
                    validateStatus={errors.rightImageId && touched.rightImageId ? 'error' : ''}
                    help={errors.rightImageId && touched.rightImageId ? errors.rightImageId : ''}
                  >
                    <ImageUpload
                      value={values.rightImageId}
                      validateStatus={errors.rightImageId && touched.rightImageId ? 'error' : ''}
                      uploadOnChange={(e) => setFieldValue('rightImageId', e)}
                      uploadOnRemove={() => setFieldValue('rightImageId', undefined)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className='h-[24px]'/>  
              <Row className="flex justify-center">
                <Button
                  loading={loading}
                  type="primary"
                  onClick={() => scrollAndSubmit({ errors, handleSubmit })}
                  size="large"
                >
                  Үнэлгээчнээр үнэлүүлэх
                </Button>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

const Container = styled.div`
  .ant-btn-color-primary {
    width: 280px;
    height: 50px;
    background-color: ${Colors.blue} !important;
  }
`;

export { AdditionalForm };